import type { PropsWithChildren } from 'react';
import { PostHogProvider as Provider } from 'posthog-js/react';

import { WebappEnv } from '@/entities/webapp-env';
import { env } from '@/env';
import { UnreachableCaseError } from '@/utils/errors/unreachable-case-error';

export type PostHogProviderProps = PropsWithChildren<{}>;
export function PostHogProvider({ children }: PostHogProviderProps) {
  if (!env.VITE_POSTHOG_ENABLE) {
    return <>{children}</>;
  }

  return (
    <Provider
      apiKey={env.VITE_POSTHOG_PUBLIC_KEY ?? ''}
      options={{
        debug: env.VITE_WEBAPP_ENV === WebappEnv.LOCAL,
        api_host: proxyUrlFromWebappEnv(env.VITE_WEBAPP_ENV),
        ui_host: 'https://eu.posthog.com',
        persistence: 'localStorage',
        person_profiles: 'identified_only',
      }}
    >
      {children}
    </Provider>
  );
}

function proxyUrlFromWebappEnv(webappEnv: WebappEnv) {
  switch (webappEnv) {
    case WebappEnv.PRODUCTION:
      return 'https://posthog.accure-platform.com';
    case WebappEnv.SANDBOX:
      return 'https://posthog-sandbox.accure-platform.com';
    case WebappEnv.STAGING:
    case WebappEnv.LOCAL:
      return 'https://posthog-staging.accure-platform.com';
    default: {
      throw new UnreachableCaseError(webappEnv);
    }
  }
}
